(function()  {

    'use strict';

    const Slideshow = function (element) {

        /// The gallery object itself
        this.element = element;

        /// The grid view of the gallery
        this.thumbnails = element.getElementsByClassName('slideshow__thumbnail');

        // The main display within the gallery that shows the prominent image
        this.display = element.getElementsByClassName('slideshow__display')[0];

        /// The navigation to browse through the gallery
        this.navigation = element.getElementsByClassName('navigation__control');

        /// The image path of the prominent image
        this.image = this.display.getElementsByTagName('IMG')[0];

        /// The alternative source of the prominent image
        this.source = this.display.getElementsByTagName('SOURCE')[0];

        /// The current index of the prominent image
        this.index = 0;

        this.browseTo = this.browseTo.bind(this);
        this.browsePrevious = this.browsePrevious.bind(this);
        this.browseNext = this.browseNext.bind(this);
        this.swapImage = this.swapImage.bind(this);

        this.initiateListener();
    }

    /**
     * Starts listening
     */
    Slideshow.prototype.initiateListener = function () {

        for (const thumbnail of this.thumbnails) {
            thumbnail.addEventListener('pointerdown', this.browseTo);
            thumbnail.addEventListener('focus', this.browseTo);
        }

        this.navigation[0].addEventListener('pointerdown', this.browsePrevious);
        this.navigation[0].addEventListener('keydown', this.browsePrevious);

        this.navigation[1].addEventListener('pointerdown', this.browseNext);
        this.navigation[1].addEventListener('keydown', this.browseNext);
    }

    /**
     * Browses through the given slide
     */
    Slideshow.prototype.browseTo = function (event) {
        this.swapImage(event.target)
    }

    /**
     * Browses the previous slide
     */
    Slideshow.prototype.browsePrevious = function(event) {

        if (event.type === 'keydown' && event.key === 'Enter' || event.type === 'pointerdown') {

            const index = this.index - 1;

            if (index < 0) {
                this.index = this.thumbnails.length - 1;

            } else {
                this.index = index;
            }

            this.swapImage(this.thumbnails[this.index]);
        }
    }

    /**
     * Browses the next slide
     */
    Slideshow.prototype.browseNext = function(event) {

        if (event.type === 'keydown' && event.key === 'Enter' || event.type === 'pointerdown') {

            const index = this.index + 1;

            if (index >= this.thumbnails.length) {
                this.index = 0

            } else {
                this.index = index;
            }

            this.swapImage(this.thumbnails[this.index]);
        }
    }

    /**
     * Swaps the image based on the selection
     */
    Slideshow.prototype.swapImage = function(target) {

        const source = target.querySelector('source');
        const image = target.querySelector('img');

        this.image.src = image.src;
        this.image.alt = image.alt;

        if (source !== undefined && this.source !== undefined) {
            this.source.srcset = source.srcset;
        }
    }

    const slideshows = document.getElementsByClassName('js-slideshow');

    for (const slideshow of slideshows) {
        new Slideshow(slideshow);
    }

}());